// cameraStore.ts
import { create } from 'zustand';
import { CameraControls } from '@react-three/drei';

type CameraControlsState = {
  controls: CameraControls | null;
  setControls: (controls: CameraControls) => void;
};

export const useCameraControlsStore = create<CameraControlsState>((set) => ({
  controls: null,
  setControls: (controls) => set({ controls }),
}));
